import React from 'react';
import { useTranslation } from 'react-i18next';

import { screens, ScreensNameType } from '@navigation';
import {
  NavigationListView,
  NavigationListViewRouteType,
} from '@components';
import { useNavOptionsSet } from '@hooks';

const ROUTES: NavigationListViewRouteType[] = [
  { screen: screens.Notifications, tKey: 'settings.notifications' },
  { screen: screens.Subscription, tKey: 'settings.subscription' },
  // { screen: screens.Language, tKey: 'settings.language' },
  { screen: screens.Security, tKey: 'settings.security' },
  { screen: screens.InviteFriend, tKey: 'settings.inviteFriend' },
  { screen: screens.Help, tKey: 'settings.help' },
  { screen: screens.About, tKey: 'settings.about' },
];

const BREADCRUMB_ROUTES: ScreensNameType[] = [
  screens.Profile,
  screens.Settings,
];

export function SettingsScreen() {
  const { t } = useTranslation();

  useNavOptionsSet({ title: t('settings.title') });

  return (
    <NavigationListView
      title={t('settings.title')}
      routes={ROUTES}
      breadcrumbRoutes={BREADCRUMB_ROUTES}
    />
  );
}
